import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ReplicatedService } from './replicated.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'replicated-delete-policy',
  providers: [
    ReplicatedService, TranslateService
  ],
  styles: [require('./replicated-vdc.scss'),require('../delete-policy/delete-policy.scss')],
  template: require('./delete-policy.html')
})

export class ReplicatedDeletePolicy {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedObject') selectedObject;
  @Input('selectedVDC') selectedVDC;
  @Output('onClose') selfClose = new EventEmitter();

  private subscribeHandler;
  private submitted: boolean = false;
  private active: boolean = true;
  private description2 = "";
  private isRequestPending: boolean = false;

  constructor(public service: ReplicatedService, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit() {
    switch(this.mode){
      case DataProtectionVariables.MODES['VAPP']:
        this.deleteVapp();
        break;
      case DataProtectionVariables.MODES['VDC']:
        this.deleteVDC();
        break;
      default :
        this.deleteVapp();
    }
  }

  onSubmitButtonClicked(f: NgForm) {
  }

  onCancelButtonClicked() {
    this.closeSelf();
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if(this.mode && changes && changes.hasOwnProperty('selectedObject') && changes.selectedObject && changes.selectedObject.hasOwnProperty('currentValue')
      && changes.selectedObject.currentValue && this.mode === DataProtectionVariables.MODES['VAPP'] ) {
        this.description2 = this.translate.instant('dpsModule.replicatedVdc.vappList.modalDialog.removeReplicationPolicy.delWarningMsg2');
    }

    if(this.mode && changes && changes.hasOwnProperty('selectedVDC') && changes.selectedVDC && changes.selectedVDC.hasOwnProperty('currentValue')
      && changes.selectedVDC.currentValue && this.mode === DataProtectionVariables.MODES['VDC'] ) {
        this.description2 = this.translate.instant('dpsModule.replicatedVdc.vdcList.modalDialog.removeReplicationPolicy.delWarningMsg2');
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  deleteVapp() {
    if(this.selectedVDC && this.selectedVDC.id !== '' &&
       this.selectedObject && this.selectedObject[0] && this.selectedObject[0].id && this.selectedObject[0].id !== '') {
          this.isRequestPending = true;
          this.subscribeHandler = this.service.removeReplicationForVapp(this.selectedVDC.id, this.selectedObject[0].id)
            .subscribe(
              res => {
                this.closeSelf();
              },
              error => this.handleError(error, 'delete vApp'),
              () => this.handleCompleted('delete vApp')
            );
    }
    else
      this.handleError('Incorrect VDC or vApp information');
  }

  deleteVDC() {
    if(this.selectedVDC && this.selectedVDC.id !== '') {
      this.isRequestPending = true;
      this.subscribeHandler = this.service.removeReplicationPolicyForVDC(this.selectedVDC.id)
        .subscribe(
          res => {
            this.closeSelf();
          },
          error => this.handleError(error, 'delete VDC'),
          () => this.handleCompleted('delete VDC')
        );
    }
    else
      this.handleError('Incorrect VDC information');
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: "close"
      });
    }
  }

  handleError(error, msg = "") {
    this.isRequestPending = false;
    this.service.logError(error, msg);
  }

  handleCompleted(msg = "") {
    this.isRequestPending = false;
    this.service.logOperationCompleted(msg)
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/replicated-vdc/delete-policy.component.ts